import React from "react";
import "./MachineTransferModal.css";

interface MachineTransferModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const MachineTransferModal: React.FC<MachineTransferModalProps> = ({
  isOpen,
  onClose,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <div className="machine-transfer-modal-overlay" onClick={onClose}>
      <div
        className="machine-transfer-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="machine-transfer-modal-close-button"
          onClick={onClose}
        >
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};

export default MachineTransferModal;
